import { Link } from "react-router-dom";
import { useEffect } from "react";

export const MobileMenu = ({ open, onClose, user, onLogout }) => {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  const items = [
    { label: "Community", to: "/community", testid: "mobile-nav-community" },
    ...(user
      ? [{ label: "Profile", to: `/u/${user.user_id}`, testid: "mobile-nav-profile" }]
      : []),
    ...(user?.role === "admin"
      ? [{ label: "Admin", to: "/admin", testid: "mobile-nav-admin", accent: true }]
      : []),
  ];

  return (
    <div
      data-testid="mobile-menu-overlay"
      className={`md:hidden fixed inset-0 z-[60] transition-opacity duration-300 ${
        open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
      }`}
      aria-hidden={!open}
    >
      <div
        className="absolute inset-0 bg-[#07070a]/95 backdrop-blur-xl"
        onClick={onClose}
      />
      <div className="relative h-full flex flex-col">
        <div className="flex items-center justify-end h-20 w-[calc(100%-32px)] mx-auto">
          <button
            data-testid="mobile-menu-close"
            aria-label="Close menu"
            onClick={onClose}
            className="p-2 -mr-2 text-white/70 hover:text-ember transition-colors"
          >
            <svg viewBox="0 0 24 24" className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="1.8">
              <path d="M6 6l12 12M18 6L6 18" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        <nav className="flex-1 flex flex-col justify-center gap-2 w-[calc(100%-48px)] mx-auto pb-24">
          {items.map((it, i) => (
            <Link
              key={it.to}
              to={it.to}
              onClick={onClose}
              data-testid={it.testid}
              style={{ transitionDelay: open ? `${80 + i * 60}ms` : "0ms" }}
              className={`display text-3xl tracking-[0.12em] py-4 border-b border-white/5 transition-all duration-500 ${
                open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"
              } ${it.accent ? "text-forge" : "text-white hover:text-ember"}`}
            >
              {it.label}
            </Link>
          ))}

          {user ? (
            <button
              data-testid="mobile-nav-logout"
              onClick={async () => {
                onClose();
                await onLogout();
              }}
              style={{ transitionDelay: open ? `${80 + items.length * 60}ms` : "0ms" }}
              className={`display text-3xl tracking-[0.12em] py-4 text-left text-white/45 hover:text-forge transition-all duration-500 ${
                open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"
              }`}
            >
              Sign out
            </button>
          ) : (
            <Link
              to="/login"
              onClick={onClose}
              data-testid="mobile-nav-signin"
              style={{ transitionDelay: open ? `${80 + items.length * 60}ms` : "0ms" }}
              className={`display text-3xl tracking-[0.12em] py-4 text-ember transition-all duration-500 ${
                open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"
              }`}
            >
              Sign in
            </Link>
          )}

          {user && (
            <div
              data-testid="mobile-menu-user"
              className={`mt-8 flex items-center gap-3 transition-opacity duration-500 ${
                open ? "opacity-100" : "opacity-0"
              }`}
              style={{ transitionDelay: open ? "320ms" : "0ms" }}
            >
              {user.picture ? (
                <img
                  src={user.picture}
                  alt={user.name}
                  className="w-9 h-9 rounded-full border border-white/20 object-cover"
                />
              ) : (
                <span className="w-9 h-9 rounded-full border border-forge/50 bg-forge/15 grid place-items-center display text-[11px] text-forge">
                  {(user.name || "F").slice(0, 2).toUpperCase()}
                </span>
              )}
              <span className="display text-[11px] tracking-[0.2em] text-white/50 truncate">
                {user.name}
              </span>
            </div>
          )}
        </nav>
      </div>
    </div>
  );
};
